import React from "react";
import PropTypes from "prop-types";
import {
    ProgressBarWrapper,
    ScoreText,
    HeaderContainer,
    ReviewText,
    CardContainer,
    HorseshoeSvg,
} from "./ReviewCard.styles";

const ReviewCard = ({ score = 4.5, label = "Overall Rating" }) => {
    const arcLength = Math.PI * 40; // Semi-circle arc length
    const progressColor = score < 4 ? "#FF6600" : "#61CBC9"; // Set color based on score

    return (
        <CardContainer>
            <HeaderContainer>
                <ReviewText>{label}</ReviewText>
            </HeaderContainer>
            <ProgressBarWrapper>
                <HorseshoeSvg>
                    <svg viewBox="0 0 100 50">
                        {/* Background track */}
                        <path
                            d="M 10 50 A 40 40 0 1 1 90 50"
                            fill="none"
                            stroke="rgba(114, 125, 135, 0.1)"
                            strokeWidth="8"
                            strokeLinecap="round"
                        />
                        {/* Progress */}
                        <path
                            d="M 10 50 A 40 40 0 1 1 90 50"
                            fill="none"
                            stroke={progressColor}
                            strokeWidth="8"
                            strokeDasharray={`${(score / 5) * arcLength} ${(1 - score / 5) * arcLength}`}
                            strokeLinecap="round"
                        />
                    </svg>
                    <ScoreText>{`${score.toFixed(2)}`}</ScoreText>
                </HorseshoeSvg>
            </ProgressBarWrapper>
        </CardContainer>
    );
};

ReviewCard.propTypes = {
    score: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
};

export default ReviewCard;
